const simplifyDisabilityPlanName = (plan) => `${plan?.salary_coverage_percentage}% salary coverage / ${plan.display_name} / ${plan?.benefit_duration}`;

export default simplifyDisabilityPlanName;
